import { inject } from 'vue'
export const OtpMfa = (to: any, from: any) => {
  const isOtpInitialized = inject('isOtpInitialized') as () => boolean
  if (!isOtpInitialized()) {
    return { name: 'LoginView' }
  }
}
